import React, { useState, useEffect } from 'react';
import { Form, Alert, Button /* , Modal */ } from 'react-bootstrap'; // Modal temporarily unused
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from '../../../../services/AxiosInstance';
import { getApiUrl } from '../../../../utils/ApiUtils';
import Swal from 'sweetalert2';
import {
  AlertTriangle,
  Calendar,
  Briefcase,
  Building2,
  DollarSign,
  MapPin,
  // Users, // Temporarily unused
  Clock,
  FileText,
  Plus,
  // Save, // Temporarily unused
  // X // Temporarily unused
} from 'lucide-react';

// Enhanced InputField component with "Add New" functionality
const InputField = ({
  icon: Icon,
  label,
  name,
  type = 'text',
  required = false,
  placeholder = '',
  description = null,
  options = null,
  formik,
  showValidation,
  disabled = false,
  onAddNew = null,
  addNewLabel = null
}) => (
  <div className="input-group">
    <div className="input-label-container">
      <label className="input-label">
        {label}
        {required && <span className="required-indicator">*</span>}
      </label>
      {description && (
        <p className="input-description">{description}</p>
      )}
    </div>
    <div className="input-container-with-action">
      <div className="input-container">
        <div className="input-icon">
          <Icon size={16} />
        </div>
        {options ? (
          <Form.Select
            name={name}
            value={formik.values[name]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={disabled}
            className={`modern-input ${formik.touched[name] && formik.errors[name] ? 'error' : ''}`}
          >
            <option value="">{placeholder}</option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Form.Select>
        ) : (
          <Form.Control
            type={type}
            name={name}
            value={formik.values[name]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder={placeholder}
            disabled={disabled}
            className={`modern-input ${formik.touched[name] && formik.errors[name] ? 'error' : ''}`}
            as={type === 'textarea' ? 'textarea' : 'input'}
            rows={type === 'textarea' ? 4 : undefined}
          />
        )}
      </div>
      {onAddNew && (
        <Button
          variant="outline-primary"
          size="sm"
          className="add-new-button"
          onClick={onAddNew}
          type="button"
        >
          <Plus size={14} className="me-1" />
          {addNewLabel || 'Lägg till'}
        </Button>
      )}
    </div>
    {showValidation && formik.touched[name] && formik.errors[name] && (
      <div className="error-message">
        <AlertTriangle size={14} />
        <span>{formik.errors[name]}</span>
      </div>
    )}
  </div>
);

const ModernContractDetailsComponent = ({ formik, companyId, showValidation = true }) => {
  // Temporarily commented out - Organization section not in use
  // const [departments, setDepartments] = useState([]);
  // const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Modal states - Temporarily commented out
  // const [showDepartmentModal, setShowDepartmentModal] = useState(false);
  // const [showPositionModal, setShowPositionModal] = useState(false);
  // const [isCreating, setIsCreating] = useState(false);

  // Temporarily commented out - Organization section not in use
  // // Load departments
  // const loadDepartments = async () => {
  //   try {
  //     const getDepartmentsApiUrl = getApiUrl(`${companyId}/hr/departments`);
  //     const result = await axios.get(getDepartmentsApiUrl, { withCredentials: true });
  //     if (result.data.status === 'success') {
  //       setDepartments(result.data.data);
  //     }
  //   } catch (error) {
  //     console.error('Error loading departments:', error);
  //     setError('Failed to load departments');
  //   }
  // };

  // // Load positions
  // const loadPositions = async () => {
  //   try {
  //     const getPositionsApiUrl = getApiUrl(`${companyId}/hr/positions`);
  //     const result = await axios.get(getPositionsApiUrl, { withCredentials: true });
  //     if (result.data.status === 'success') {
  //       setPositions(result.data.data);
  //     }
  //   } catch (error) {
  //     console.error('Error loading positions:', error);
  //     setError('Failed to load positions');
  //   }
  // };

  // Load data on component mount
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      // await Promise.all([loadDepartments(), loadPositions()]); // Temporarily commented out
      setLoading(false);
    };
    loadData();
  }, [companyId]);

  // Temporarily commented out - Organization section not in use
  // // Department creation form
  // const departmentFormik = useFormik({
  //   initialValues: {
  //     name: '',
  //     description: '',
  //     cost_center: ''
  //   },
  //   validationSchema: Yup.object({
  //     name: Yup.string().required('Avdelningsnamn är obligatoriskt'),
  //     description: Yup.string(),
  //     cost_center: Yup.string()
  //   }),
  //   onSubmit: async (values, { resetForm }) => {
  //     setIsCreating(true);
  //     try {
  //       const createDepartmentApiUrl = getApiUrl(`${companyId}/hr/departments`);
  //       const response = await axios.post(createDepartmentApiUrl, values, { withCredentials: true });
  //
  //       if (response.data.status === 'success') {
  //         await loadDepartments(); // Reload departments
  //         setShowDepartmentModal(false);
  //         resetForm();
  //
  //         await Swal.fire({
  //           icon: 'success',
  //           title: 'Sparat!',
  //           text: 'Avdelningen har skapats framgångsrikt.',
  //           timer: 1500
  //         });

  //         // Auto-select the newly created department by name since we have the response
  //         setTimeout(() => {
  //           const newDepartment = departments.find(dept => dept.name === values.name);
  //           if (newDepartment) {
  //             formik.setFieldValue('department_id', newDepartment.department_id);
  //           }
  //         }, 100);
  //       }
  //     } catch (error) {
  //       console.error('Error creating department:', error);
  //       await Swal.fire({
  //         icon: 'error',
  //         title: 'Fel',
  //         text: error.response?.data?.message || 'Ett fel inträffade vid skapande av avdelningen.'
  //       });
  //     } finally {
  //       setIsCreating(false);
  //     }
  //   }
  // });

  // // Position creation form
  // const positionFormik = useFormik({
  //   initialValues: {
  //     title: '',
  //     description: '',
  //     level: '',
  //     category: '',
  //     min_salary: '',
  //     max_salary: ''
  //   },
  //   validationSchema: Yup.object({
  //     title: Yup.string().required('Positionstitel är obligatoriskt'),
  //     description: Yup.string(),
  //     level: Yup.string(),
  //     category: Yup.string(),
  //     min_salary: Yup.number().typeError('Minimumlön måste vara en siffra').nullable(),
  //     max_salary: Yup.number()
  //       .typeError('Maximumlön måste vara en siffra')
  //       .when('min_salary', (min_salary, schema) => {
  //         return min_salary && schema.min(min_salary, 'Maximumlön måste vara större än minimumlön');
  //       })
  //       .nullable()
  //   }),
  //   onSubmit: async (values, { resetForm }) => {
  //     setIsCreating(true);
  //     try {
  //       const createPositionApiUrl = getApiUrl(`${companyId}/hr/positions`);
  //       const response = await axios.post(createPositionApiUrl, values, { withCredentials: true });
  //
  //       if (response.data.status === 'success') {
  //         await loadPositions(); // Reload positions
  //         setShowPositionModal(false);
  //         resetForm();
  //
  //         await Swal.fire({
  //           icon: 'success',
  //           title: 'Sparat!',
  //           text: 'Positionen har skapats framgångsrikt.',
  //           timer: 1500
  //         });

  //         // Auto-select the newly created position by title
  //         setTimeout(() => {
  //           const newPosition = positions.find(pos => pos.title === values.title);
  //           if (newPosition) {
  //             formik.setFieldValue('position_id', newPosition.position_id);
  //           }
  //         }, 100);
  //       }
  //     } catch (error) {
  //       console.error('Error creating position:', error);
  //       await Swal.fire({
  //         icon: 'error',
  //         title: 'Fel',
  //         text: error.response?.data?.message || 'Ett fel inträffade vid skapande av positionen.'
  //       });
  //     } finally {
  //       setIsCreating(false);
  //     }
  //   }
  // });

  // Calculate working hours percentage
  const workingHoursPercentage = formik.values.workweek ? 
    Math.round((parseFloat(formik.values.workweek) / 40) * 100) : 100;

  // Calculate adjusted workweek hours for part-time
  let adjustedWorkweekHours = null;
  if (
    formik.values.employmentextent === 'Part-time' &&
    formik.values.parttimePercentage &&
    formik.values.workweek
  ) {
    adjustedWorkweekHours =
      (parseFloat(formik.values.workweek) * parseFloat(formik.values.parttimePercentage)) / 100;
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-4">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Laddar...</span>
          </div>
          <div className="mt-2 text-muted">Laddar formulärdata...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger">
        <AlertTriangle size={16} className="me-2" />
        {error}
      </Alert>
    );
  }

  return (
    <>
      <style>{`
        .form-section {
          margin-bottom: 2rem;
        }
        
        .section-title {
          font-size: 1.125rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 1.5rem;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding-bottom: 1rem;
          border-bottom: 1px solid #f1f5f9;
        }
        
        .form-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
          align-items: start;
        }
        
        .input-group {
          display: flex;
          flex-direction: column;
        }
        
        .input-label-container {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          margin-bottom: 0.5rem;
        }
        
        .input-label {
          font-size: 0.875rem;
          font-weight: 500;
          color: #374151;
          margin: 0 0 0.25rem 0;
          display: flex;
          align-items: center;
          line-height: 1.2;
        }
        
        .required-indicator {
          color: #ef4444;
          margin-left: 0.25rem;
        }
        
        .input-description {
          font-size: 0.75rem;
          color: #6b7280;
          margin: 0;
          line-height: 1.3;
          height: 16px;
        }
        
        .input-container-with-action {
          display: flex;
          gap: 0.5rem;
          align-items: stretch;
        }
        
        .input-container {
          position: relative;
          display: flex;
          align-items: center;
          flex: 1;
        }
        
        .add-new-button {
          display: flex;
          align-items: center;
          justify-content: center;
          white-space: nowrap;
          border-radius: 8px;
          font-size: 0.875rem;
          font-weight: 500;
          min-width: auto;
          padding: 0.75rem 1rem;
        }
        
        .input-icon {
          position: absolute;
          left: 0.75rem;
          z-index: 1;
          color: #6b7280;
          pointer-events: none;
          display: flex;
          align-items: center;
        }
        
        .modern-input {
          width: 100%;
          padding: 0.75rem 0.75rem 0.75rem 2.5rem;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          font-size: 0.875rem;
          background: white;
          color: #374151;
          transition: all 0.2s ease;
        }
        
        .modern-input:focus {
          outline: none;
          border-color: var(--bs-primary);
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }
        
        .modern-input.error {
          border-color: var(--bs-danger);
          box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
        }
        
        .error-message {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #ef4444;
          font-size: 0.75rem;
          font-weight: 500;
          margin-top: 0.25rem;
          min-height: 20px;
        }
        
        .info-box {
          background: #f0f9ff;
          border: 1px solid #bae6fd;
          border-radius: 8px;
          padding: 1rem;
          margin-top: 1rem;
          display: flex;
          align-items: flex-start;
          gap: 0.75rem;
        }
        
        .info-text {
          font-size: 0.875rem;
          color: #0c4a6e;
          margin: 0;
        }
        
        .checkbox-group {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 1rem;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          margin-top: 1rem;
        }
        
        .checkbox-label {
          font-size: 0.875rem;
          font-weight: 500;
          color: #374151;
          cursor: pointer;
          margin: 0;
        }
        
        .calculation-display {
          background: #fef3c7;
          border: 1px solid #f59e0b;
          border-radius: 8px;
          padding: 1rem;
          margin-top: 1rem;
        }
        
        .calculation-text {
          font-size: 0.875rem;
          color: #92400e;
          margin: 0;
          font-weight: 500;
        }
      `}</style>

      {/* Basic Contract Information */}
      <div className="form-section">
        <div className="section-title">
          <Calendar size={20} />
          Grundläggande kontraktsinformation
        </div>

        <div className="form-grid">
          <InputField
            icon={Calendar}
            label="Startdatum"
            name="startdate"
            type="date"
            required={true}
            formik={formik}
            showValidation={showValidation}
          />

          <InputField
            icon={Briefcase}
            label="Anställningsform"
            name="employmenttype"
            required={true}
            placeholder="Välj anställningsform"
            options={[
              { value: 'Permanent', label: 'Tillsvidareanställning' },
              { value: 'Probation', label: 'Provanställning' },
              { value: 'Hourly', label: 'Timanställning' }
            ]}
            formik={formik}
            showValidation={showValidation}
          />

          <InputField
            icon={DollarSign}
            label="Grundlön (SEK/månad)"
            name="salary"
            type="number"
            required={true}
            placeholder="0"
            formik={formik}
            showValidation={showValidation}
          />

          <InputField
            icon={Calendar}
            label="Löneperiod"
            name="salaryperiod"
            required={true}
            options={[
              { value: 'Advance', label: 'Förskott' },
              { value: 'Arrears', label: 'Efterskott' }
            ]}
            formik={formik}
            showValidation={showValidation}
          />

          <InputField
            icon={Clock}
            label="Arbetstimmar per vecka"
            name="workweek"
            type="number"
            required={true}
            placeholder="40"
            description={`Standard är 40 timmar (${workingHoursPercentage}%)`}
            formik={formik}
            showValidation={showValidation}
          />

          <InputField
            icon={Building2}
            label="Anställningsomfattning"
            name="employmentextent"
            required={true}
            placeholder="Välj omfattning"
            options={[
              { value: 'Fulltime', label: 'Heltid' },
              { value: 'Part-time', label: 'Deltid' }
            ]}
            formik={formik}
            showValidation={showValidation}
          />

          {formik.values.employmentextent === 'Part-time' && (
            <InputField
              icon={Building2}
              label="Deltidsprocent"
              name="parttimePercentage"
              type="number"
              required={true}
              placeholder="75"
              description="Ange procent av heltid (1-99%)"
              formik={formik}
              showValidation={showValidation}
            />
          )}
        </div>

        {/* Display adjusted workweek hours for part-time */}
        {adjustedWorkweekHours !== null && (
          <div className="calculation-display">
            <p className="calculation-text">
              Arbetstid: <strong>{adjustedWorkweekHours.toFixed(2)} timmar per vecka</strong>
              {' '}(baserat på deltid {formik.values.parttimePercentage}% av {formik.values.workweek} timmar)
            </p>
          </div>
        )}
      </div>

      {/* Organization Information - Temporarily commented out */}
      {/* <div className="form-section">
        <div className="section-title">
          <Users size={20} />
          Organisation och position
        </div>

        <div className="form-grid">
          <InputField
            icon={Building2}
            label="Avdelning"
            name="department_id"
            required={true}
            placeholder="Välj avdelning"
            options={departments.map(dept => ({
              value: dept.department_id,
              label: dept.name
            }))}
            formik={formik}
            showValidation={showValidation}
            onAddNew={() => setShowDepartmentModal(true)}
            addNewLabel="Ny avdelning"
          />

          <InputField
            icon={Briefcase}
            label="Position"
            name="position_id"
            required={true}
            placeholder="Välj position"
            options={positions.map(pos => ({
              value: pos.position_id,
              label: `${pos.title}${pos.level ? ` (${pos.level})` : ''}`
            }))}
            formik={formik}
            showValidation={showValidation}
            onAddNew={() => setShowPositionModal(true)}
            addNewLabel="Ny position"
          />
        </div>

        {departments.length === 0 && positions.length === 0 && (
          <div className="info-box">
            <AlertTriangle size={16} className="text-warning" />
            <p className="info-text">
              Inga avdelningar eller positioner är tillgängliga. Kontakta administratören för att lägga till dessa.
            </p>
          </div>
        )}
      </div> */}

      {/* Benefits and Conditions */}
      <div className="form-section">
        <div className="section-title">
          <FileText size={20} />
          Förmåner och villkor
        </div>

        <div className="form-grid">
          <InputField
            icon={Calendar}
            label="Semesterdagar per år"
            name="vacation_days"
            type="number"
            required={true}
            placeholder="25"
            description="Standard är 25 semesterdagar per år"
            formik={formik}
            showValidation={showValidation}
          />

          <InputField
            icon={Clock}
            label="Uppsägningstid (veckor)"
            name="notice_period_weeks"
            type="number"
            required={true}
            placeholder="4"
            description="Uppsägningstid i veckor"
            formik={formik}
            showValidation={showValidation}
          />

          <InputField
            icon={Calendar}
            label="Provanställning (månader)"
            name="probation_period_months"
            type="number"
            placeholder=""
            description="Lämna tomt om ingen provanställning"
            formik={formik}
            showValidation={showValidation}
          />
        </div>

        {/*
          Hidden for now — worker_category + high_risk_protection are wired
          end-to-end (backend defaults: 'tjansteman' / 0) but omitted from the
          UI until a customer actually needs arbetare BAS-routing (7010) or
          Försäkringskassan §13 karensavdrag-exemption. Re-introduce here when
          a customer requests it; initial values already live in the formik
          config on NewContract / EditContract.
        */}
      </div>

      {/* Tax Information - Temporarily commented out */}
      {/* <div className="form-section">
        <div className="section-title">
          <DollarSign size={20} />
          Skatteinformation
        </div>

        <div className="form-grid">
          <InputField
            icon={DollarSign}
            label="Skattetabell"
            name="taxtable"
            required={true}
            placeholder="33"
            options={Array.from({ length: 14 }, (_, i) => ({
              value: (i + 29).toString(),
              label: `Tabell ${i + 29}`
            }))}
            formik={formik}
            showValidation={showValidation}
          />

          <InputField
            icon={DollarSign}
            label="Skattekolumn"
            name="taxcolumn"
            required={true}
            options={Array.from({ length: 6 }, (_, i) => ({
              value: (i + 1).toString(),
              label: `Kolumn ${i + 1}`
            }))}
            formik={formik}
            showValidation={showValidation}
          />
        </div>
      </div> */}

      {/* Workplace Information */}
      <div className="form-section">
        <div className="section-title">
          <MapPin size={20} />
          Arbetsplats
        </div>

        <div className="form-grid">
          <InputField
            icon={Building2}
            label="Tjänsteställe"
            name="workplace"
            required={true}
            placeholder="Välj tjänsteställe"
            options={[
              { value: 'Main', label: 'Huvudkontor' },
              { value: 'Branch', label: 'Filial' },
              { value: 'Remote', label: 'Distans' },
              { value: 'Other', label: 'Annat' }
            ]}
            formik={formik}
            showValidation={showValidation}
          />

          <InputField
            icon={MapPin}
            label="Arbetsplatsens adress"
            name="workplaceAddress"
            required={true}
            placeholder="Gatunamn XX"
            formik={formik}
            showValidation={showValidation}
          />

          <InputField
            icon={MapPin}
            label="Arbetsplatsens ort"
            name="workplaceCity"
            required={true}
            placeholder="Ortnamn"
            formik={formik}
            showValidation={showValidation}
          />
        </div>

        <div className="form-grid mt-4">
          <div className="input-group" style={{ minHeight: 'auto' }}>
            <label className="input-label">
              Övriga villkor
            </label>
            <div className="input-container">
              <div className="input-icon">
                <FileText size={16} />
              </div>
              <Form.Control
                as="textarea"
                rows={4}
                name="otherterms"
                value={formik.values.otherterms}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Beskriv eventuella särskilda villkor eller tillägg till anställningsavtalet..."
                className="modern-input"
              />
            </div>
          </div>
        </div>

        {/* Checkbox for collective agreement */}
        <div className="checkbox-group">
          <Form.Check
            type="checkbox"
            name="accordingtocollectiveagreement"
            checked={formik.values.accordingtocollectiveagreement}
            onChange={formik.handleChange}
          />
          <label className="checkbox-label">
            Enligt kollektivavtal
          </label>
        </div>
      </div>

      {/* Department Creation Modal - Temporarily commented out */}
      {/* <Modal show={showDepartmentModal} onHide={() => setShowDepartmentModal(false)} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <Building2 size={20} className="me-2" />
            Skapa ny avdelning
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={departmentFormik.handleSubmit}>
          <Modal.Body>
            <div className="form-grid">
              <InputField
                icon={Building2}
                label="Avdelningsnamn"
                name="name"
                required={true}
                placeholder="Ange avdelningsnamn"
                formik={departmentFormik}
                showValidation={true}
              />

              <InputField
                icon={FileText}
                label="Beskrivning"
                name="description"
                placeholder="Beskriv avdelningens syfte"
                formik={departmentFormik}
                showValidation={true}
              />

              <InputField
                icon={DollarSign}
                label="Kostnadscenter"
                name="cost_center"
                placeholder="T.ex. IT001"
                description="Valfritt kostnadscenter för rapportering"
                formik={departmentFormik}
                showValidation={true}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDepartmentModal(false)}
              disabled={isCreating}
            >
              <X size={16} className="me-2" />
              Avbryt
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={isCreating || !departmentFormik.isValid}
            >
              {isCreating ? (
                <>
                  <div className="spinner-border spinner-border-sm me-2" role="status">
                    <span className="visually-hidden">Sparar...</span>
                  </div>
                  Sparar...
                </>
              ) : (
                <>
                  <Save size={16} className="me-2" />
                  Skapa avdelning
                </>
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal> */}

      {/* Position Creation Modal - Temporarily commented out */}
      {/* <Modal show={showPositionModal} onHide={() => setShowPositionModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <Briefcase size={20} className="me-2" />
            Skapa ny position
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={positionFormik.handleSubmit}>
          <Modal.Body>
            <div className="form-grid">
              <InputField
                icon={Briefcase}
                label="Positionstitel"
                name="title"
                required={true}
                placeholder="T.ex. Senior Software Developer"
                formik={positionFormik}
                showValidation={true}
              />

              <InputField
                icon={FileText}
                label="Beskrivning"
                name="description"
                placeholder="Beskriv positionen"
                formik={positionFormik}
                showValidation={true}
              />

              <InputField
                icon={Building2}
                label="Nivå"
                name="level"
                placeholder="Välj nivå"
                options={[
                  { value: 'Junior', label: 'Junior' },
                  { value: 'Medior', label: 'Medior' },
                  { value: 'Senior', label: 'Senior' },
                  { value: 'Lead', label: 'Lead' },
                  { value: 'Manager', label: 'Manager' },
                  { value: 'Director', label: 'Director' },
                  { value: 'Executive', label: 'Executive' }
                ]}
                formik={positionFormik}
                showValidation={true}
              />

              <InputField
                icon={Users}
                label="Kategori"
                name="category"
                placeholder="Välj kategori"
                options={[
                  { value: 'Development', label: 'Development' },
                  { value: 'Sales', label: 'Sales' },
                  { value: 'Marketing', label: 'Marketing' },
                  { value: 'HR', label: 'HR' },
                  { value: 'Finance', label: 'Finance' },
                  { value: 'Operations', label: 'Operations' },
                  { value: 'Management', label: 'Management' }
                ]}
                formik={positionFormik}
                showValidation={true}
              />

              <InputField
                icon={DollarSign}
                label="Minimumlön (SEK)"
                name="min_salary"
                type="number"
                placeholder="35000"
                description="Valfritt löneintervall"
                formik={positionFormik}
                showValidation={true}
              />

              <InputField
                icon={DollarSign}
                label="Maximumlön (SEK)"
                name="max_salary"
                type="number"
                placeholder="65000"
                description="Valfritt löneintervall"
                formik={positionFormik}
                showValidation={true}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowPositionModal(false)}
              disabled={isCreating}
            >
              <X size={16} className="me-2" />
              Avbryt
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={isCreating || !positionFormik.isValid}
            >
              {isCreating ? (
                <>
                  <div className="spinner-border spinner-border-sm me-2" role="status">
                    <span className="visually-hidden">Sparar...</span>
                  </div>
                  Sparar...
                </>
              ) : (
                <>
                  <Save size={16} className="me-2" />
                  Skapa position
                </>
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal> */}
    </>
  );
};

export default ModernContractDetailsComponent;
